import { Box, TodoPrioIcon } from "arkh";

import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoListItemPriority_todo$key } from "./__generated__/TodoListItemPriority_todo.graphql";
import { UrgentAnimation } from "./UrgentAnimation";

export function TodoListItemPriority(props: {
  todo: TodoListItemPriority_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemPriority_todo on Todo {
        priority
        status
      }
    `,
    props.todo
  );
  if (todo.priority === "DEFAULT") {
    return null;
  }
  return (
    <Box spaceRight="small">
      {todo.priority === "URGENT" && todo.status === "PENDING" ? (
        <UrgentAnimation />
      ) : null}

      <TodoPrioIcon
        isInactive={todo.status === "DONE"}
        priority={todo.priority}
        hideDefault
      />
    </Box>
  );
}
